export function migrateV1ToV2(resume) {
  const next = JSON.parse(JSON.stringify(resume || {}));
  next.schemaVersion = 2;
  
  if (!next.sections) {
    next.sections = ['contact', 'summary', 'experience', 'education', 'skills', 'projects'];
  }
  
  if (!next.sectionSettings) {
    next.sectionSettings = {};
  }
  
  // Map any existing populated legacy sections automatically to V2
  const legacyChecks = ['certifications', 'languages', 'achievements', 'extracurricular', 'internships'];
  legacyChecks.forEach(secId => {
    const list = next[secId] || next[`${secId}List`] || [];
    if (list.length > 0) {
      if (!next.sections.includes(secId)) {
        next.sections.push(secId);
      }
      next.sectionSettings[secId] = {
        enabled: true,
        visible: true,
        collapsed: false,
        order: next.sections.length - 1
      };
    }
  });

  return next;
}
